define((require) => {
    "use strict";

    const GroupModel      = require("shared/ui/groups/GroupModel");
    const Locale          = require("shared/services/localization/Locale");
    const ExperienceModel = require("shared/ui/experience/ExperienceModel");

    /**
     * Represents a group of <tt>locale</tt>'s - referencing <tt>ExperienceModel</tt>'s.
     *
     * @class LocalizationGroup
     */

    return GroupModel.extend("LocalizationGroup", {

        /**
         * @inheritDoc
         */
        types: [Locale, ExperienceModel],

        /**
         * LocalizationGroup is not considered as one unit when published or scheduled.
         *
         * @override
         * @returns {boolean}
         */
        isOneUnit() {
            return false;
        }

    }, {

        /**
         * @inheritDoc
         */
        type: "LocalizationGroup"
    });
});



// WEBPACK FOOTER //
// ./src/shared/services/localization/LocalizationGroup.js